<div class="animated-image-wrapper">
  <div *ngIf="showForeground" class="animated-image-foreground"></div>
  <div *ngIf="showTopForeground" class="animated-image-top-foreground"></div>

  <div class="animated-image-placeholder"></div>
  <div #image class="animated-image-content animated-image-content-hidden" [style.backgroundImage]="'url(' + imageUrl + ')'"></div>
</div>
